import React from 'react';
import { Eye, EyeOff, Trash2, PlusCircle } from 'lucide-react';

const keys = [
  {
    id: 'key001',
    name: 'OpenAI - Production',
    service: 'OpenAI',
    key: 'sk-****************abcd',
    owner: 'admin@agentic.ai',
    createdOn: '2025-04-20',
    status: 'Active',
    usage: 'LLM Chat',
  },
  {
    id: 'key002',
    name: 'Anthropic - Internal',
    service: 'Claude',
    key: 'sk-****************1234',
    owner: 'dev@agentic.ai',
    createdOn: '2025-04-18',
    status: 'Inactive',
    usage: 'Background Agents',
  },
];

const Keys = () => {
  return (
    <div>
      {/* Header + Add Key */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-semibold text-white">API & Auth Keys</h2>
          <p className="text-sm text-gray-400">Manage credentials for LLMs, vector stores, services & integrations.</p>
        </div>
        <button className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm shadow">
          <PlusCircle className="w-4 h-4 mr-2" /> Add New Key
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto border border-neutral-800 rounded">
        <table className="min-w-full text-sm text-left text-gray-300">
          <thead className="bg-neutral-900 text-gray-400">
            <tr>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Service</th>
              <th className="px-4 py-2">Key</th>
              <th className="px-4 py-2">Usage</th>
              <th className="px-4 py-2">Owner</th>
              <th className="px-4 py-2">Created On</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {keys.map((k) => (
              <tr key={k.id} className="border-t border-neutral-800 hover:bg-neutral-800/30">
                <td className="px-4 py-3">{k.name}</td>
                <td className="px-4 py-3">{k.service}</td>
                <td className="px-4 py-3 font-mono text-xs">{k.key}</td>
                <td className="px-4 py-3">{k.usage}</td>
                <td className="px-4 py-3">{k.owner}</td>
                <td className="px-4 py-3 font-mono text-xs">{k.createdOn}</td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-block px-2 py-1 rounded text-xs font-medium ${
                      k.status === 'Active'
                        ? 'bg-green-700 text-green-100'
                        : 'bg-red-700 text-red-100'
                    }`}
                  >
                    {k.status}
                  </span>
                </td>
                <td className="px-4 py-3 flex justify-end gap-2">
                  <button title="View Key" className="text-indigo-400 hover:text-white">
                    <Eye className="w-4 h-4" />
                  </button>
                  <button title="Delete Key" className="text-red-400 hover:text-red-200">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Keys;
